import { Stack, StackProps, styled, Tooltip } from "@mui/material";
import { tooltipClasses, TooltipProps } from "@mui/material/Tooltip";

type IWidgetCommonContainer = {
  hasSidePadding?: boolean;
  isLoading?: boolean;
  hoverBorderAccent?: boolean;
}

export const CommonWidgetContainer = styled(Stack)<StackProps & IWidgetCommonContainer>(
  ({ theme, hasSidePadding = true, isLoading = false, hoverBorderAccent = true }) => ({
    "&:hover": {
      border: hoverBorderAccent && `2px solid ${theme.customColors.borderAccent}`
    },
    background: theme.customColors.backgroundCard,
    border: `2px solid  ${theme.customColors.border}`,
    borderRadius: "1.125rem",
    display: "flex",
    flexDirection: "column",
    gap: "1rem",
    maxWidth: "24rem",
    minHeight: isLoading ? "10rem" : "0rem",
    padding: hasSidePadding ? "1rem" : "1rem 0rem",
    transition: "all 0.2s ease",
    width: "24rem",
    [theme.breakpoints.down("sm")]: {
      maxWidth: "100%", //Why 20rem instead of 100%?
      minWidth: "15rem",
      width:"100%"
    }
  }));


export const InfoTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip { ...props } classes={ { popper: className } } />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.customColors.backgroundCard
  },
  [`& .${tooltipClasses.arrow}::before`]: {
    border: `1px solid ${theme.customColors.border}`,
    backgroundColor: theme.customColors.backgroundCard
  },
  [`& .${tooltipClasses.tooltip}`]: {
    background: theme.customColors.backgroundCard,
    border: `1px solid ${theme.customColors.border}`,
    borderRadius: theme.spacing(1),
    color: theme.customColors.textWidget,
    fontSize: "0.75rem",
    maxWidth: "240px",
    padding: theme.spacing(1),
    textAlign: "center"
  }
}));
